import React from 'react';
import {
  Grid,
  Button,
  TextField,
  Typography,
  Modal
} from '@material-ui/core';
import { Close, InsertDriveFile } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import withRoot from '../../withRoot';
import metaFetch from '../../utils/metaFetch';
import { Redirect } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import { I18n } from '../../i18n';

const styles = theme => ({
  root: {
    textAlign: 'left',
    width: '94%',
    margin: '30px 3%',
  },
  modal: {
    position: 'absolute',
    width: theme.spacing.unit * 150,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
    left: '50%',
    height: '90vh',
    overflowY: 'auto',
    top: '50%',
    transform: `translate(-50%, -50%)`,
  },
  textField: {
    width: '100%',
    marginBottom: '20px'
  },
  alignRight: {
    textAlign: 'right'
  },
  data: {
    '& h4': {
      marginBottom: '0'
    }
  },
  buttonCancel: {
    marginRight: '20px'
  },
  fileInput: {
    marginBottom: '20px',
    '& label': {
      display: 'block',
      fontSize: '12px',
      color: 'rgba(0,0,0,0.54)',
      marginBottom: '4px'
    }
  }
});

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

class ItemEdit extends React.Component {
  state = {
    open: true,
    documentFile: null,
  }

  handleClose = () => {
    this.setState({ open: false });
  }

  renderRedirect = () => {
      if (!this.state.open) {
        return <Redirect to='/cso-grants' />
      }
  }

  saveItem = async (values) => {
    const formData = new FormData();
    if (values.year !== undefined && values.year !== '') formData.append('year', values.year);
    if (values.projectTitle) formData.append('projectTitle', values.projectTitle);
    if (values.cso) formData.append('cso', values.cso);
    if (this.state.documentFile) formData.append('document', this.state.documentFile);

    const method = values.id ? 'PUT' : 'POST';
    const endpoint = values.id ? `/cso_grants/${values.id}` : '/cso_grants';

    await metaFetch(endpoint, { method, body: formData });

    this.setState({ open: false });
    this.props.handleItemSave();
  }

  onSubmit = async values => {
    await sleep(300)
    this.saveItem(values);
  }

  render() {
      const { classes, item, lang } = this.props;
      const { documentFile } = this.state;
      return (
        <>
          {this.renderRedirect()}

          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.state.open}
            onClose={this.handleClose}
          >
            <div className="modal">
              <a className="close" onClick={this.handleClose}>
                <Close/>
              </a>

              <Grid container spacing={24} alignItems='center'>
                <Grid item xs={6}>
                  <Typography gutterBottom variant="h2" component="h2" style={{'color': '#fdbb2d'}}>
                    { item ? `${I18n[lang].csoGrants.edit} ${item.id}` : I18n[lang].csoGrants.create }
                  </Typography>
                </Grid>
              </Grid>
              <Typography className={classes.data}>
                <Form
                  onSubmit={this.onSubmit}
                  initialValues={item}
                  render={({ handleSubmit, form, submitting, pristine, values }) => (
                    <form onSubmit={handleSubmit}>

                    <Field name="year">
                      {({ input }) => <TextField label={I18n[lang].csoGrant.year} margin="normal" className='text-field' variant="outlined" {...input} />}
                    </Field>

                    <Field name="projectTitle">
                      {({ input }) => <TextField label={I18n[lang].csoGrant.projectTitle} margin="normal" className='text-field' variant="outlined" {...input} />}
                    </Field>

                    <Field name="cso">
                      {({ input }) => <TextField label={I18n[lang].csoGrant.cso} margin="normal" className='text-field' variant="outlined" {...input} />}
                    </Field>

                    <div className={classes.fileInput}>
                      <label>{I18n[lang].csoGrant.document}</label>
                      <input
                        type="file"
                        onChange={(e) => this.setState({ documentFile: e.target.files[0] || null })}
                      />
                      {documentFile && (
                        <span style={{ marginLeft: '8px', fontSize: '12px' }}>
                          {documentFile.name} ({(documentFile.size / 1024 / 1024).toFixed(2)} MB)
                        </span>
                      )}
                      {!documentFile && item && item.documentUrl && (
                        <span style={{ marginLeft: '8px', fontSize: '12px', color: 'rgba(0,0,0,0.54)' }}>
                          <InsertDriveFile style={{ fontSize: '14px', verticalAlign: 'middle' }} /> current file attached
                        </span>
                      )}
                    </div>

                      <Grid container spacing={24} alignItems='center'>
                        <Grid item xs={12} className={classes.alignRight}>
                          <Button variant="contained" className='button-cancel' onClick={this.handleClose}>
                            <i></i>
                            {I18n[lang].common.cancel}
                          </Button>
                          <Button variant="contained" className='button-submit' type="submit" color="primary">
                            <i></i>
                            {I18n[lang].common.save}
                          </Button>
                        </Grid>
                      </Grid>

                    </form>
                  )}
                />
              </Typography>
            </div>
          </Modal>
        </>
      );
  }
}

export default withRoot(withStyles(styles)(ItemEdit));
